// LRS Staking Contract ABI

export const LRS_STAKING_ABI = [
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "inputs": [],
        "name": "contractStartTime",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "getAllRunningStakes",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "stakeID",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "stakeAddress",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "stakeAmt",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "stakeStartTime",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "stakeStatus",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct StakingLRS.StakeInfo[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "getCurrentStakeAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "getUserAllStakes",
        "outputs": [
            {
                "internalType": "uint256[]",
                "name": "",
                "type": "uint256[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "implementation",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "initContract",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "lastStakeID",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "stake",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalStakeAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalStakeCount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "userStakes",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "stakeID",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "stakeAddress",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "stakeAmt",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "stakeStartTime",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "stakeStatus",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "stakeID",
                "type": "uint256"
            }
        ],
        "name": "withdraw",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }
] as const;

// Contract addresses
export const LRS_STAKING_CONTRACT = (import.meta.env.VITE_LRS_STAKING_CONTRACT_ADDRESS || '') as `0x${string}`;
export const REWARD_POOL_TOKEN = (import.meta.env.VITE_LRS_STAKING_REWARD_ACCOUNT_ADDRESS || '') as `0x${string}`;

// LRS Token address (Wrapped LRS on Larissa network - used for staking)
export const LRS_TOKEN_ADDRESS = (import.meta.env.VITE_WLRS_TOKEN_ADDRESS || '') as `0x${string}`; // WLRS

